import React from "react";

import { DataTableBody, DataTableHead, DataTableRow } from "../Component";
import VacanciesPageTableBodyItem from "./VacanciesPageTableBodyItem";

import { useVacancyPageContext } from "../../hooks/useVacancyPageContext";

const VacanciesPageTableBody = () => {
  const { vacancies } = useVacancyPageContext();

  return (
    <DataTableBody>
      <DataTableHead>
        <DataTableRow text="Order" />
        <DataTableRow text="Job Title" />
        <DataTableRow text="Type" />
        <DataTableRow text="Deadline" />
        <DataTableRow text="Created Date" />
        <DataTableRow text="Active" />
        <DataTableRow className="nk-tb-col-tools" noText />
      </DataTableHead>
      {vacancies?.map((item) => (
        <VacanciesPageTableBodyItem key={item?.id} item={item} />
      ))}
    </DataTableBody>
  );
};

export default VacanciesPageTableBody;
